import 'bootstrap/dist/landing/venta-ana-mena/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import 'vue2-animate/dist/vue2-animate.min.css'

import Vue from 'vue'
import App from './App.vue'
import router from './router'
import { store } from './store/index'
import vueAnalytics from './plugins/vue-analytics'
import { i18n } from './plugins/vue-i18n'
import { vueBootstrap } from './plugins/vue-bootstrap'
import vueAxios from './plugins/vue-axios'
import permalinkfilter from './filters/permalinkfilter'
import removeQuotes from './filters/removeQuotes'
import truncate from './filters/truncate'
import vueSentry from './plugins/vue-sentry'
import veeValidate from './plugins/vee-validate'
import vueCookies from './plugins/vue-cookies'
import vueMoment from './plugins/vue-moment'
import vueLoadScript from './plugins/vue-plugin-load-script'
import vueFacebook from './plugins/vue-facebook'
import vueFacebookPixel from './plugins/vue-facebook-pixel'
import vueLodash from './plugins/vue-lodash'
import vueGoogleMaps from './plugins/vue-googlemaps'
import vueScrollTo from './plugins/vue-scrollto'
import refreshToken from './plugins/mixins/refreshToken'

Vue.config.productionTip = false

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
